<div style="width: 80%; margin: 0 auto;" class="text-center mb-3">
    <h2 style=" text-decoration: overline;
  text-decoration-color: red; /* Set the color of the overline */
  text-decoration-thickness: 2px; /">CATOGARIES</h2>
    <p>Manufacturer of a wide range of products which include 3inch Shringar Mukut, Embroidery Mukut and Yellow Mukut
        Shringar
        Manufacturer of a wide range of products which include 3inch Shringar Mukut.</p>
</div>

<div class="carousel-container">
    <!-- Left Arrow -->
    <button class="carousel-arrow left" (click)="prevImage()">
        <i class="fa fa-chevron-left"></i>
    </button>

    <!-- Visible Images -->
    <div class="carousel-images-1">
        <div *ngFor="let image of visibleImages" class="carousel-item-1">
            <img [src]="image.image" alt="Category Image">
            <div (click)="navigateToProducts(image.Id)" class="overlay">
                <span class="overlay-text">View Products</span>
            </div>
        </div>
    </div>

    <!-- Right Arrow -->
    <button class="carousel-arrow right" (click)="nextImage()">
        <i class="fa fa-chevron-right"></i>
    </button>
</div>



